export default function EFMember(props) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M29.5 12.5H10.75C9.36929 12.5 8.25 13.6193 8.25 15V45C8.25 46.3807 9.36929 47.5 10.75 47.5H50.75C52.1307 47.5 53.25 46.3807 53.25 45V41.25"
                stroke="url(#paint0_linear_2302_14536)"
                strokeWidth="2.6"
                strokeLinecap="round"
            />
            <path
                d="M40.8145 27.5C44.9566 27.5 48.3145 24.1421 48.3145 20C48.3145 15.8579 44.9566 12.5 40.8145 12.5C36.6723 12.5 33.3145 15.8579 33.3145 20C33.3145 24.1421 36.6723 27.5 40.8145 27.5Z"
                stroke="url(#paint1_linear_2302_14536)"
                strokeWidth="2.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M53.3123 35.5234C50.8708 30.7529 45.8121 27.5 40.8121 27.5C35.8121 27.5 33.3211 28.9161 30.75 31.25"
                stroke="url(#paint2_linear_2302_14536)"
                strokeWidth="2.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M18.25 25H25.75" stroke="url(#paint3_linear_2302_14536)" strokeWidth="2.6" strokeLinecap="round" />
            <path d="M18.25 37.5H43.25" stroke="url(#paint4_linear_2302_14536)" strokeWidth="2.6" strokeLinecap="round" />
            <defs>
                <linearGradient id="paint0_linear_2302_14536" x1="8.20924" y1="12.5" x2="49.969" y2="8.90848" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF971E" />
                    <stop offset="1" stopColor="#FF4E17" />
                </linearGradient>
                <linearGradient id="paint1_linear_2302_14536" x1="33.3009" y1="12.5" x2="47.2613" y2="11.5662" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF971E" />
                    <stop offset="1" stopColor="#FF4E17" />
                </linearGradient>
                <linearGradient id="paint2_linear_2302_14536" x1="30.7296" y1="27.5" x2="51.1012" y2="23.668" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF971E" />
                    <stop offset="1" stopColor="#FF4E17" />
                </linearGradient>
                <linearGradient id="paint3_linear_2302_14536" x1="18.2432" y1="25" x2="23.8448" y2="22.1898" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF971E" />
                    <stop offset="1" stopColor="#FF4E17" />
                </linearGradient>
                <linearGradient id="paint4_linear_2302_14536" x1="18.2274" y1="37.5" x2="24.3833" y2="27.2054" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF971E" />
                    <stop offset="1" stopColor="#FF4E17" />
                </linearGradient>
            </defs>
        </svg>
    );
}
